module.exports = __webpack_public_path__ + "Server-Disabled.AzureSubscription.271d7db785f778ac49f255c0c9013c92.hashedasset.svg";